import React from 'react'
import { styled, Flex, Span } from '@fareye/ui'
import { toTileCase } from '@fareye/utils'
import { useTranslation } from '@fareye/common'

const GroupedTags = styled(Flex)`
  span:last-child {
    border-radius: 0 4px 4px 0;
  }
  span:first-child {
    border-radius: 4px 0 0 4px;
  }
  span {
    cursor: pointer;
    text-align: center;
    padding: 1vmin 2vmin;
    height: fit-content;
    border: 1px solid #a8a8a8;
    color: #727272;
    margin-right: -1px;
    &.active {
      color: #fff;
      border: 1px solid rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
  }
`

export const TransportModeFilter = ({
  summaryList,
  selectedMode,
  setSelectedMode
}: any) => {
  const { t } = useTranslation()
  return (
    <GroupedTags data-testid="summary" style={{ padding: '10px' }}>
      {summaryList.map((item: any, index: number) => {
        const { label, value } = item
        return (
          <Span
            data-testid={`summary-item-${label}`}
            key={index}
            onClick={() => setSelectedMode(label)}
            className={selectedMode === label ? 'active' : ''}
          >{`${t(toTileCase(label))} (${value})`}</Span>
        )
      })}
    </GroupedTags>
  )
}
